export default "__VITE_ASSET__M0bY7q4u__"